document.addEventListener("DOMContentLoaded", function () {
  gsap.registerPlugin(ScrollTrigger);

  const hero = document.querySelector(".index_banner_sec");
  const bannerLogo = document.querySelector(".banner-logo-img");
  const header = document.querySelector(".section-header");

  if (!hero || !bannerLogo || !header) return;

  const isDesktop = window.innerWidth >= 992;

  ScrollTrigger.create({
    trigger: hero,
    start: "top top",
    end: () => `bottom top+=${header.offsetHeight}`,
    scrub: true,

    onUpdate: (self) => {
      const progress = self.progress;

      gsap.set(bannerLogo, {
        scale: 1 - progress,
        opacity: 1 - progress,
        y: isDesktop ? progress * 220 : 0, // Move only on desktop
        transformOrigin: "center center"
      });
    },

    onLeave: () => {
      header.classList.add("show-header");
    },

    onEnterBack: () => {
      header.classList.remove("show-header");
    }
  });

  
  // left and right image animation
    gsap.fromTo(
    ".banner-animate-img--left img",
    {
        rotation: -15,
        y: 60,
        transformOrigin: "right center"
    },
    {
        rotation: 0,
        y: 0,
        ease: "none",
        scrollTrigger: {
        trigger: ".wholesale-banner",
        start: "top bottom",
        end: "bottom top",
        scrub: 0.5
        }
    }
    );
    // Right image
    gsap.fromTo(
    ".banner-animate-img--right img",
    {
        rotation: 15,
        y: 60,
        transformOrigin: "left center"
    },
    {
        rotation: 0,
        y: 0,
        ease: "none",
        scrollTrigger: {
        trigger: ".wholesale-banner",
        start: "top bottom",
        end: "bottom top",
        scrub: 0.5
        }
    }
    );
});